import React from 'react';
import { AnimatedSection } from './AnimatedSection';
export function ProblemSection() {
  return <section className="w-full px-6 py-16 md:py-20" data-id="element-264">
      <div className="max-w-2xl mx-auto" data-id="element-265">
        <AnimatedSection data-id="element-266">
          <div className="w-12 h-px bg-sand mx-auto mb-12" data-id="element-267" />
        </AnimatedSection>

        <AnimatedSection data-id="element-268">
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal leading-tight mb-4" data-id="element-269">
            El problema real:
          </h2>
          <p className="font-serif text-2xl md:text-3xl text-teal leading-snug mb-10" data-id="element-270">
            no te falta fuerza de voluntad.
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.1} data-id="element-271">
          <p className="text-charcoal text-base md:text-lg leading-relaxed font-medium mb-8" data-id="element-272">
            Te falta una cosa: orden de prioridad.
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.15} data-id="element-273">
          <div className="space-y-4 text-charcoal/80 text-base md:text-lg leading-relaxed mb-8" data-id="element-274">
            <p data-id="element-275">
              Porque la mayoría de "soluciones" te hacen empezar por lo más
              difícil:
            </p>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.2} data-id="element-276">
          <div className="space-y-4 mb-10" data-id="element-277">
            <div className="flex items-start gap-4 bg-cream-dark/60 rounded-xl p-5" data-id="element-278">
              <span className="text-sand text-xl font-bold mt-0.5" aria-hidden="true" data-id="element-279">
                ✕
              </span>
              <div data-id="element-280">
                <p className="text-charcoal font-medium" data-id="element-281">
                  "Organiza por categorías"
                </p>
                <p className="text-warm-gray text-sm mt-1" data-id="element-282">
                  Demasiadas decisiones.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4 bg-cream-dark/60 rounded-xl p-5" data-id="element-283">
              <span className="text-sand text-xl font-bold mt-0.5" aria-hidden="true" data-id="element-284">
                ✕
              </span>
              <div data-id="element-285">
                <p className="text-charcoal font-medium" data-id="element-286">
                  "Haz una rutina diaria"
                </p>
                <p className="text-warm-gray text-sm mt-1" data-id="element-287">
                  Constancia que hoy no tienes.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4 bg-cream-dark/60 rounded-xl p-5" data-id="element-288">
              <span className="text-sand text-xl font-bold mt-0.5" aria-hidden="true" data-id="element-289">
                ✕
              </span>
              <div data-id="element-290">
                <p className="text-charcoal font-medium" data-id="element-291">
                  "Haz un fin de semana de limpieza profunda"
                </p>
                <p className="text-warm-gray text-sm mt-1" data-id="element-292">
                  Maratón que te rompe.
                </p>
              </div>
            </div>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.25} data-id="element-293">
          <div className="space-y-3 text-charcoal/80 text-base md:text-lg leading-relaxed" data-id="element-294">
            <p data-id="element-295">¿Resultado?</p>
            <p data-id="element-296">Empiezas. Te agotas.</p>
            <p data-id="element-297">Recaes.</p>
            <p className="font-serif text-xl text-charcoal italic" data-id="element-298">
              Y la culpa crece.
            </p>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}